import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'service-area-tariffs' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
